module.exports = __webpack_public_path__ + "static/media/newimg.820f2a87.png";